import { useTranslation } from "react-i18next";
import { LogOut, Plus } from "lucide-react";
import { LangToggle, ThemeToggle } from "../../components/controls/Toggles";
import { NeuButton } from "../../components/neu/Neu";
import { usePerms } from "../../hooks/usePerms";

export const PlatformHeader = ({ user, onAdd, onLogout }) => {
  const { t } = useTranslation();
  const canManage = usePerms().can("companies");
  const name = user?.name || user?.email;
  return (
    <header className="flex flex-wrap items-center justify-between gap-4">
      <div>
        <h1 className="text-3xl font-black tracking-tight sm:text-4xl">{t("platform.title")}</h1>
        <p className="mt-1 text-sm text-muted-foreground">{t("platform.subtitle")}</p>
        <div className="mt-2 flex flex-wrap items-center gap-2" data-testid="platform-current-user">
          <span className="text-sm font-bold">{name}</span>
          <span className="rounded-xl bg-primary/10 px-2 py-0.5 text-xs font-semibold text-primary">
            {t(`staff.roles.${user?.role || "platform_admin"}`)}
          </span>
          <span className="text-xs text-muted-foreground" dir="ltr">{user?.email}</span>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <LangToggle />
        <ThemeToggle />
        <NeuButton variant="primary" data-testid="company-add-btn" className={`flex items-center gap-2 ${canManage ? "" : "hidden"}`} onClick={onAdd}>
          <Plus className="h-4 w-4" /> {t("platform.addCompany")}
        </NeuButton>
        <NeuButton data-testid="platform-logout" className="px-4 py-2" onClick={onLogout}>
          <LogOut className="h-4 w-4" />
        </NeuButton>
      </div>
    </header>
  );
};
